import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import BoxSelect from './boxSelect';
import SelectScreen from './selectScreen';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import Request from 'superagent';
import { RingLoader } from 'react-spinners';
import '../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import './css/configure.css';

export default function ConfigureScreen({ userProfile, eventID, modulesConfiguredCount, screenCountForEvent, newEventScreenAdded }) {
    const [eventScreenModules, setEventScreenModules] = useState([]);
    const [addButtonVisible, setAddButtonVisible] = useState(false);
    const [removeButtonVisible, setRemoveButtonVisible] = useState(false);
    const [items, setItems] = useState([]);
    const [thisRowSelected, setThisRowSelected] = useState([]);
    const [screenNameShowDelete, setScreenNameShowDelete] = useState(false);
    const [keyCount, setKeyCount] = useState(0);
    const [selectedScreen, setSelectedScreen] = useState({ deviceWidth: 'desktop' });
    const [selectedModuleRow, setSelectedModuleRow] = useState(null);
    const [loading, setLoading] = useState(false);

    const boxSelectRef = useRef(null);

    // CWRP: clear modules when eventID resets to 0
    const firstEventIDRender = useRef(true);
    useEffect(() => {
        if (firstEventIDRender.current) { firstEventIDRender.current = false; return; }
        if (eventID === 0) {
            setEventScreenModules([]);
            setItems([]);
        }
    }, [eventID]);

    function formatEventModulesDataRow(dataRow, kc) {
        return {
            ...dataRow,
            visible: true,
            key: dataRow.event_modules_id + ':' + dataRow.modules_definition_id + '|' + kc,
            i: dataRow.event_modules_id + ':' + dataRow.modules_definition_id + '|' + kc,
            min_width: parseInt(dataRow.min_width, 10),
            min_height: parseInt(dataRow.min_height, 10),
            x: 0, y: 0, w: 0, h: 0,
            description: (() => {
                let desc = dataRow.name !== '' && dataRow.pairing_relationship !== 's'
                    ? dataRow.module_type + ' (' + dataRow.name + ')'
                    : dataRow.module_type;
                return desc + (dataRow.is_control === 't' ? ' - Control' : ' - Display');
            })(),
        };
    }

    function updateDimensions() {
        if (!boxSelectRef.current) return [0, 0, '0', '100%'];
        let containerWidth = boxSelectRef.current.parentElement.offsetWidth;
        let containerPercentWidth = '100%';
        let boxHeight = 0;
        let rowHeight = 0;
        const deviceType = selectedScreen.deviceType;
        if (deviceType === 'desktop') {
            boxHeight = containerWidth / 1.77;
            rowHeight = (boxHeight - 130) / 12;
        } else if (deviceType === 'tablet') {
            boxHeight = containerWidth / 1.33;
            rowHeight = (boxHeight - 130) / 13;
        } else if (deviceType === 'mobileLandscape') {
            boxHeight = containerWidth / 1.77;
            rowHeight = (boxHeight - 130) / 5;
        } else {
            containerWidth = containerWidth / 2;
            boxHeight = containerWidth * 1.77;
            rowHeight = (boxHeight - 130) / 10;
            containerPercentWidth = '50%';
        }
        return [boxHeight, rowHeight, containerWidth + 'px', containerPercentWidth];
    }

    function findSpotOnScreen(minH, minW) {
        const screenPopulation = Array.from({ length: 13 }, () => Array(12).fill(0));
        for (let x = selectedScreen.maxCols; x < 12; x++) for (let y = 0; y < 13; y++) screenPopulation[y][x] = 1;
        for (let x = 0; x < 12; x++) for (let y = selectedScreen.maxRows; y < 13; y++) screenPopulation[y][x] = 1;
        items.forEach(d => {
            if (d.w !== 0) {
                for (let x = d.x; x < d.w + d.x; x++) for (let y = d.y; y < d.h + d.y; y++) screenPopulation[y][x] = 1;
            }
        });

        for (let x = 0; x < 13 - minW; x++) {
            for (let y = 0; y < 13 - minH; y++) {
                if (screenPopulation[y][x] === 0) {
                    let collisionFound = false;
                    for (let nx = x; nx < x + minW; nx++) for (let ny = y; ny < y + minH; ny++) if (screenPopulation[ny][nx] === 1) collisionFound = true;
                    if (!collisionFound) return { x, y };
                }
            }
        }
        return { x: 99, y: 99 };
    }

    function newEventScreenModuleSelected(screen) {
        setLoading(true);
        const maxCols = screen.deviceType === 'mobilePortrait' ? 4 : screen.deviceType === 'mobileLandscape' ? 8 : screen.deviceType === 'tablet' ? 8 : 12;
        const maxRows = screen.deviceType === 'mobilePortrait' ? 10 : screen.deviceType === 'mobileLandscape' ? 5 : screen.deviceType === 'tablet' ? 13 : 12;
        const updatedScreen = { ...screen, maxCols, maxRows };
        setSelectedScreen(updatedScreen);
        newEventScreenAdded(updatedScreen);
        getEventModulesByScreen(updatedScreen);
    }

    function getEventModulesByScreen(screen) {
        const kc = keyCount;
        const scrn = screen ?? selectedScreen;
        const params = JSON.stringify([{ event_screen_id: scrn.eventScreenID }]);
        const url = userProfile[0].serverIP + '/php/ob_clock.php?argument1=getEventModulesByScreen&argument2=' + params;
        Request.get(url).then(response => {
            if (response.body[0].Result !== 'OK') return;
            const singlePairing = new Set();
            const singlePairedRows = [];
            let modules = [];

            response.body[0].data.forEach(dataRow => {
                const row = formatEventModulesDataRow(dataRow, kc);
                if (row.pairing_relationship === 's') {
                    if (!singlePairing.has(row.module_type_id)) singlePairing.add(row.module_type_id);
                    singlePairedRows.push(row);
                } else {
                    modules.push(row);
                }
            });

            const url2 = userProfile[0].serverIP + '/php/ob_clock.php?argument1=getEventScreenModule&argument2=' + params;
            Request.get(url2).then(secondResponse => {
                if (secondResponse.body[0].Result !== 'OK') return;
                setScreenNameShowDelete(secondResponse.body[0].rowCount === 0);

                const newItems = [];
                secondResponse.body[0].data.forEach(esmRow => {
                    if (singlePairing.has(esmRow.module_type_id)) {
                        singlePairing.delete(esmRow.module_type_id);
                        const idx = singlePairedRows.findIndex(r => r.event_modules_id === esmRow.event_modules_id);
                        if (idx !== -1) modules.push(singlePairedRows.splice(idx, 1)[0]);
                    }
                    modules.forEach((m, i) => {
                        if (m.event_modules_id === esmRow.event_modules_id && m.event_screen_id === esmRow.event_screen_id) {
                            modules[i] = { ...m, x: parseInt(esmRow.x, 10), y: parseInt(esmRow.y, 10), w: parseInt(esmRow.w, 10), h: parseInt(esmRow.h, 10), static: false, event_screen_module_id: esmRow.event_screen_module_id };
                            if (modules[i].w !== 0) newItems.push(modules[i]);
                        }
                    });
                });

                singlePairing.forEach(module_type_id => {
                    const idx = singlePairedRows.findIndex(r => r.event_modules_id === module_type_id);
                    if (idx !== -1) modules.push(formatEventModulesDataRow(singlePairedRows.splice(idx, 1)[0], kc));
                });

                setItems(newItems);
                setLoading(false);
                setEventScreenModules(modules);
                setKeyCount(prev => prev + 1);
            });
        });
    }

    function saveEventScreenModule(dataRecord) {
        const params = JSON.stringify([{
            event_screen_module_id: dataRecord.event_screen_module_id,
            event_screen_id: dataRecord.event_screen_id,
            x: dataRecord.x, y: dataRecord.y, w: dataRecord.w, h: dataRecord.h,
            event_modules_id: dataRecord.event_modules_id,
        }]);
        Request.get(userProfile[0].serverIP + '/php/ob_clock.php?argument1=saveEventScreenModule&argument2=' + params)
            .then(r => { if (r.body[0].Result === 'OK') getEventModulesByScreen(); });
    }

    function deleteEventScreenModule(dataRecord) {
        const params = JSON.stringify([{ event_screen_module_id: dataRecord.event_screen_module_id, event_screen_id: dataRecord.event_screen_id }]);
        Request.get(userProfile[0].serverIP + '/php/ob_clock.php?argument1=deleteEventScreenModule&argument2=' + params)
            .then(r => {
                if (r.body[0].Result === 'OK') {
                    setScreenNameShowDelete(r.body[0].data[0].recordCount === 0);
                    getEventModulesByScreen();
                }
            });
    }

    function onItemChange(itemRow) {
        const prefix = itemRow.i.substring(0, itemRow.i.indexOf('|'));
        let updatedDataRow = null;
        let changeResize = true;
        const newItems = items.map(d => {
            const dPrefix = d.key.substring(0, d.key.indexOf('|'));
            if (dPrefix === prefix) {
                if (d.w === itemRow.w && d.h === itemRow.h) changeResize = false;
                return { ...d, w: itemRow.w, h: itemRow.h, x: itemRow.x, y: itemRow.y, key: d.event_modules_id + ':' + d.modules_definition_id + '|' + keyCount, i: d.event_modules_id + ':' + d.modules_definition_id + '|' + keyCount };
            }
            return { ...d, key: d.event_modules_id + ':' + d.modules_definition_id + '|' + keyCount, i: d.event_modules_id + ':' + d.modules_definition_id + '|' + keyCount };
        });
        setThisRowSelected([newItems.find(d => d.key.substring(0, d.key.indexOf('|')) === prefix)?.key ?? '']);

        const newEventScreenModules = eventScreenModules.map(d => {
            const dPrefix = d.key?.substring(0, d.key.indexOf('|'));
            if (dPrefix === prefix) {
                updatedDataRow = { ...d, w: itemRow.w, h: itemRow.h, x: itemRow.x, y: itemRow.y };
                return { ...updatedDataRow, key: d.event_modules_id + ':' + d.modules_definition_id + '|' + keyCount };
            }
            return { ...d, key: d.event_modules_id + ':' + d.modules_definition_id + '|' + keyCount };
        });

        setEventScreenModules(newEventScreenModules);
        if (updatedDataRow) saveEventScreenModule(updatedDataRow);
        if (changeResize) setItems(newItems);
        setKeyCount(prev => prev + 1);
    }

    function addToScreen() {
        const newItems = items.map(d => ({ ...d, key: d.event_modules_id + ':' + d.modules_definition_id + '|' + keyCount, static: false }));
        let savedRow = null;
        const newEventScreenModules = eventScreenModules.map(d => {
            if (d.event_modules_id === selectedModuleRow.event_modules_id && d.event_screen_id === selectedModuleRow.event_screen_id) {
                const coOrds = findSpotOnScreen(parseInt(d.min_height, 10), parseInt(d.min_width, 10));
                if (coOrds.x === 99) { alert('No room on dashboard'); return d; }
                const updated = { ...d, w: parseInt(d.min_width, 10), h: parseInt(d.min_height, 10), minW: parseInt(d.min_width, 10), minH: parseInt(d.min_height, 10), x: coOrds.x, y: coOrds.y, static: false, key: d.event_modules_id + ':' + d.modules_definition_id + '|' + keyCount, i: d.event_modules_id + ':' + d.modules_definition_id + '|' + keyCount, event_screen_module_id: 0 };
                newItems.push(updated);
                savedRow = updated;
                setScreenNameShowDelete(false);
                return updated;
            }
            return d;
        });
        if (savedRow) saveEventScreenModule(savedRow);
        setItems(newItems);
        setEventScreenModules(newEventScreenModules);
        setRemoveButtonVisible(false);
        setAddButtonVisible(false);
        setThisRowSelected([]);
        setKeyCount(prev => prev + 1);
    }

    function removeFromScreen() {
        const newItems = items.filter(d => d.event_modules_id !== selectedModuleRow.event_modules_id || d.modules_definition_id !== selectedModuleRow.modules_definition_id)
            .map(d => ({ ...d, key: d.event_modules_id + ':' + d.modules_definition_id + '|' + keyCount }));
        setItems(newItems);

        const newEventScreenModules = eventScreenModules.map(d => {
            if (d.event_modules_id === selectedModuleRow.event_modules_id && d.event_screen_id === selectedModuleRow.event_screen_id) {
                const updated = { ...d, event_screen_module_id: selectedModuleRow.event_screen_module_id, x: 0, y: 0, w: 0, h: 0 };
                deleteEventScreenModule(updated);
                return updated;
            }
            return d;
        });
        setEventScreenModules(newEventScreenModules);
        setRemoveButtonVisible(false);
        setAddButtonVisible(false);
        setThisRowSelected([]);
        setKeyCount(prev => prev + 1);
    }

    function onRowClicked(row) {
        setSelectedModuleRow(row);
        setRemoveButtonVisible(row.w !== 0);
        setAddButtonVisible(row.w === 0);
        const newItems = items.map(d => ({ ...d, static: false, i: d.event_modules_id + ':' + d.modules_definition_id + '|' + keyCount }));
        setItems(newItems);
        const newEventScreenModules = eventScreenModules.map(d => ({ ...d, key: d.event_modules_id + ':' + d.modules_definition_id + '|' + keyCount }));
        setEventScreenModules(newEventScreenModules);
        setThisRowSelected([row.key]);
        setKeyCount(prev => prev + 1);
    }

    function itemDeleted() {
        setScreenNameShowDelete(false);
        setSelectedScreen(prev => ({ ...prev, eventScreenID: 0 }));
    }

    const [boxHeight, rowHeight, containerWidth] = boxSelectRef.current ? updateDimensions() : [0, 0, '0'];
    const boxDivStyle = { width: containerWidth, height: boxHeight, overflowY: 'scroll', backgroundColor: 'black' };
    const addButtonsStyle = { display: addButtonVisible && selectedScreen.eventScreenID !== 0 ? 'block' : 'none', width: '100%' };
    const removeButtonsStyle = { display: removeButtonVisible ? 'block' : 'none', width: '100%' };
    const screensVisible = { display: modulesConfiguredCount === 0 ? 'none' : 'block' };
    const selectRowProp = { mode: 'radio', clickToSelect: true, bgColor: 'yellow', hideSelectColumn: true, onSelect: onRowClicked, selected: thisRowSelected };
    const options = { defaultSortName: 'description', defaultSortOrder: 'asc' };

    return (
        <div style={screensVisible}>
            <div style={{ height: 0, width: 0, left: '40%', top: '25%', zIndex: 1, position: 'absolute' }}>
                <RingLoader color="#d41e3d" loading={loading} size={300} />
            </div>
            <Grid fluid={true}>
                <Col xs={6}>
                    <Row>
                        <SelectScreen
                            newEventScreenModuleSelected={newEventScreenModuleSelected}
                            newItemsCreated={() => {}}
                            itemDeleted={itemDeleted}
                            screenCountForEvent={screenCountForEvent}
                            userProfile={userProfile}
                            eventID={eventID}
                            refreshScreenList={0}
                            allowForNewScreen={true}
                            screenNameShowDelete={screenNameShowDelete} />
                    </Row>
                    <Row style={{ height: '20px' }} />
                    <Row>
                        <BootstrapTable data={eventScreenModules} selectRow={selectRowProp} options={options} striped hover height="280px">
                            <TableHeaderColumn hidden isKey={true} dataField="key">ID</TableHeaderColumn>
                            <TableHeaderColumn className="screenModuleHeader" dataFormat={formatModuleName} dataField="description">Modules</TableHeaderColumn>
                            <TableHeaderColumn width="20%" dataSort={true} hidden dataField="visible" filter={{ type: 'TextFilter', defaultValue: 'true' }}>Visible</TableHeaderColumn>
                        </BootstrapTable>
                        <Button style={addButtonsStyle} name="add" bsStyle="primary" onClick={addToScreen}>Add</Button>
                        <Button style={removeButtonsStyle} name="remove" bsStyle="danger" onClick={removeFromScreen}>Remove</Button>
                    </Row>
                </Col>
                <Col xs={6} style={{ paddingRight: 0 }}>
                    <div key="outerBoxSelect" ref={boxSelectRef}>
                        {eventScreenModules.length > 0 && (
                            <div key={selectedScreen.deviceType} style={boxDivStyle}>
                                <BoxSelect items={items} itemChanged={onItemChange} rowHeight={rowHeight} selectedScreen={selectedScreen} />
                            </div>
                        )}
                    </div>
                </Col>
            </Grid>
        </div>
    );
}

function formatModuleName(cell, row) {
    return row.w === 0 ? `${cell}` : `<span style='color: red'> ${cell}</span>`;
}
